import React, {useEffect, useMemo} from 'react';
import PropTypes from "prop-types";
import { Link } from 'react-router-dom';
import { Col, Collapse, Row } from 'reactstrap';
import withRouter from '../../Components/Common/withRouter';

// Import Data
import navdata from "../LayoutMenuData";
//i18n
import { withTranslation } from "react-i18next";

const HorizontalLayout = (props : any) => {
    const navData = navdata().props.children;
    const menuItems = useMemo(() => {
        let visibleMenuItems: any = [];
        let menuSplitContainer = 6;

        navData.forEach(function (value: any, key: number) {
            if (value['isHeader']) {
                menuSplitContainer++;
            }
            if (key < menuSplitContainer) {
                visibleMenuItems.push(value);
            }
        });

        return visibleMenuItems;
    }, [navData]);

    const path = props.router.location.pathname;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        const initMenu = () => {
            const pathName = process.env.PUBLIC_URL + path;
            const ul = document.getElementById("navbar-nav");
            if (!ul) {
                return;
            }
            const items : any = ul.getElementsByTagName("a");
            let itemsArray = [...items]; // converts NodeList to Array
            removeActivation(itemsArray);
            let matchingMenuItem = itemsArray.find((x) => {
                return x.pathname === pathName;
            });
            if (matchingMenuItem) {
                activateParentDropdown(matchingMenuItem);
            }
        };
        initMenu();
    }, [path, props.layoutType]);

    function activateParentDropdown(item : any) {
        item.classList.add("active");
        let parentCollapseDiv = item.closest(".collapse.menu-dropdown");

        if (parentCollapseDiv) {

            // to set aria expand true remaining
            const parentElement = parentCollapseDiv.parentElement;
            const parentTrigger = parentElement?.children?.[0] as HTMLElement | undefined;

            parentCollapseDiv.classList.add("show");
            parentTrigger?.classList.add("active");
            parentTrigger?.setAttribute("aria-expanded", "true");

            const parentMenu = parentElement?.closest(".collapse.menu-dropdown") as HTMLElement | null;
            if (parentMenu) {
                parentMenu.classList.add("show");

                const parentElementDiv = parentMenu.previousElementSibling as HTMLElement | null;
                parentElementDiv?.closest(".collapse")?.classList.add("show");
                parentElementDiv?.classList.add("active");

                const parentElementSibling = parentElementDiv?.parentElement?.parentElement?.parentElement?.previousElementSibling as HTMLElement | null;
                parentElementSibling?.classList.add("active");
            }
            return false;
        }
        return false;
    }

    const removeActivation = (items : any) => {
        let actiItems = items.filter((x : any) => x.classList.contains("active"));

        actiItems.forEach((item : any) => {
            if (item.classList.contains("menu-link")) {
                if (!item.classList.contains("active")) {
                    item.setAttribute("aria-expanded", false);
                }
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
            }
            if (item.classList.contains("nav-link")) {
                if (item.nextElementSibling) {
                    item.nextElementSibling.classList.remove("show");
                }
                item.setAttribute("aria-expanded", false);
            }
            item.classList.remove("active");
        });
    };

    const getLinkTargetProps = (menuItem: any) => ({
        ...(menuItem?.target ? {target: menuItem.target} : {}),
        ...(menuItem?.target === "_blank" ? {rel: "noopener noreferrer"} : {}),
    });

    return (
        <React.Fragment>
            {(menuItems || []).map((item  :any, key : number) => {
                return (
                    <React.Fragment key={key}>
                        {/* Main Header */}
                        {!item['isHeader'] ?
                            (item.subItems ? (
                                <li className="nav-item">
                                    <Link
                                        onClick={item.click}
                                        className="nav-link menu-link"
                                        to={item.link ? item.link : "/#"}
                                        data-bs-toggle="collapse"
                                    >
                                        <i className={item.icon}></i> <span data-key="t-apps">{props.t(item.label)}</span>
                                    </Link>
                                    <Collapse
                                        className={item.id === "baseUi" && item.subItems.length > 13 ? "menu-dropdown mega-dropdown-menu" : "menu-dropdown"}
                                        isOpen={item.stateVariables}
                                        id="sidebarApps">
                                        {/* subItms  */}
                                        {item.id === "baseUi" && item.subItems.length > 13 ? (
                                            <React.Fragment>
                                                <Row>
                                                    {item.subItems && ((item.subItems || []).map((subItem : any, key : number) => (
                                                            <React.Fragment key={key}>
                                                                {key % 2 === 0 ? (
                                                                    <Col lg={4}>
                                                                        <ul className="nav nav-sm flex-column">
                                                                            <li className="nav-item">
                                                                                <Link to={item.subItems[key].link} className="nav-link" {...getLinkTargetProps(item.subItems[key])}>{item.subItems[key].label}</Link>
                                                                            </li>
                                                                        </ul>
                                                                    </Col>
                                                                ) : (
                                                                    <Col lg={4}>
                                                                        <ul className="nav nav-sm flex-column">
                                                                            <li className="nav-item">
                                                                                <Link to={item.subItems[key].link} className="nav-link" {...getLinkTargetProps(item.subItems[key])}>{item.subItems[key].label}</Link>
                                                                            </li>
                                                                        </ul>
                                                                    </Col>
                                                                )
                                                                }
                                                            </React.Fragment>
                                                        ))
                                                    )}
                                                </Row>
                                            </React.Fragment>
                                        ) : (
                                            <ul className="nav nav-sm flex-column test">
                                                {item.subItems && ((item.subItems || []).map((subItem  : any, key : number) => (
                                                        <React.Fragment key={key}>
                                                            {!subItem.isChildItem ? (
                                                                <li className="nav-item">
                                                                    <Link
                                                                        to={subItem.link ? subItem.link : "/#"}
                                                                        className="nav-link"
                                                                        {...getLinkTargetProps(subItem)}
                                                                    >
                                                                        {props.t(subItem.label)}
                                                                    </Link>
                                                                </li>
                                                            ) : (
                                                                <li className="nav-item">
                                                                    <Link
                                                                        onClick={subItem.click}
                                                                        className="nav-link"
                                                                        to="/#"
                                                                        data-bs-toggle="collapse"
                                                                    > {props.t(subItem.label)}
                                                                    </Link>
                                                                    <Collapse className="menu-dropdown" isOpen={subItem.stateVariables} id="sidebarEcommerce">
                                                                        <ul className="nav nav-sm flex-column">
                                                                            {/* child subItms  */}
                                                                            {subItem.childItems && (
                                                                                (subItem.childItems || []).map((subChildItem : any, key : number) => (
                                                                                    <React.Fragment key={key}>
                                                                                        {!subChildItem.isChildItem ? (
                                                                                            <li className="nav-item">
                                                                                                <Link
                                                                                                    to={subChildItem.link ? subChildItem.link : "/#"}
                                                                                                    className="nav-link"
                                                                                                    {...getLinkTargetProps(subChildItem)}
                                                                                                >
                                                                                                    {props.t(subChildItem.label)}
                                                                                                </Link>
                                                                                            </li>
                                                                                        ) : (
                                                                                            <li className="nav-item">
                                                                                                <Link
                                                                                                    onClick={subChildItem.click}
                                                                                                    className="nav-link"
                                                                                                    to="/#"
                                                                                                    data-bs-toggle="collapse"
                                                                                                > {props.t(subChildItem.label)}
                                                                                                </Link>
                                                                                                <Collapse className="menu-dropdown" isOpen={subChildItem.stateVariables} id="sidebarEcommerce">
                                                                                                    <ul className="nav nav-sm flex-column">
                                                                                                        {/* child subItms  */}
                                                                                                        {subChildItem.childItems && (
                                                                                                            (subChildItem.childItems || []).map((subSubChildItem : any, key : number) => (
                                                                                                                <li className="nav-item apex" key={key}>
                                                                                                                    <Link
                                                                                                                        to={subSubChildItem.link ? subSubChildItem.link : "/#"}
                                                                                                                        className="nav-link"
                                                                                                                        {...getLinkTargetProps(subSubChildItem)}
                                                                                                                    >
                                                                                                                        {props.t(subSubChildItem.label)}
                                                                                                                    </Link>
                                                                                                                </li>
                                                                                                            ))
                                                                                                        )}
                                                                                                    </ul>
                                                                                                </Collapse>
                                                                                            </li>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                ))
                                                                            )}
                                                                        </ul>
                                                                    </Collapse>
                                                                </li>
                                                            )}
                                                        </React.Fragment>
                                                    ))
                                                )}
                                            </ul>
                                        )}
                                    </Collapse>
                                </li>
                            ) : (
                                <li className="nav-item">
                                    <Link
                                        className="nav-link menu-link"
                                        to={item.link ? item.link : "/#"}
                                        {...getLinkTargetProps(item)}>
                                        <i className={item.icon}></i> <span>{props.t(item.label)}</span>
                                    </Link>
                                </li>
                            ))
                            : (<li className="menu-title"><span data-key="t-menu">{props.t(item.label)}</span></li>)}
                    </React.Fragment>
                );
            })}
            {/* menu Items */}
        </React.Fragment >
    );
};

HorizontalLayout.propTypes = {
    location: PropTypes.object,
    t: PropTypes.any,
};

export default withRouter(withTranslation()(HorizontalLayout));
